import currentDevice from 'current-device';

const isIphone = currentDevice.ios();
export default isIphone;
